module.exports = __webpack_public_path__ + "img/pGoogle.68cbe3fa.svg";